/*
 * @Descripttion:智齿对接页面功能嵌套层数过多，抽离部分根变量，统一管理
 * @startVersion:2.5.2
 * @updateVersion:2.5.2
 * @Author: zhubaodong
 * @Date: 2021-08-25 15:42:14
 * @LastEditors: fanxiaoning
 * @LastEditTime: 2022-08-18 11:26:02
 */
export interface IState {
  pageToken: string;
  mainTabActive: number;
  mainCustomerInfo: any;
  isOneToOneStrengthening: boolean;
  mainUserInfo: any;
  mainShyUserInfo: any;
  zhichiUserPhone: string;
  fromWechat: boolean;
  disturbInfo: any[];
  updateComPenSateList: boolean;
}
export default {
  namespaced: true,
  state: (): IState => {
    return {
      // k8s-TOKEN
      pageToken: "",
      // 首页选中tab下标
      mainTabActive: 0,
      // 客服信息
      mainCustomerInfo: null,
      // 用户是否为强化课时包学员
      isOneToOneStrengthening: false,
      // 1v1用户信息
      mainUserInfo: null,
      // 书画院用户信息
      mainShyUserInfo: null,
      // 智齿客服用户手机号 !唯一
      zhichiUserPhone: "",
      //企业微信进入标识
      fromWechat: false,
      //勿扰标签信息
      disturbInfo: [],
      //是否更新赔付列表
      updateComPenSateList: false
    };
  },
  mutations: {
    setPageToken(state: IState, value: string) {
      state.pageToken = value;
    },
    setMainTabActive(state: IState, value: number) {
      state.mainTabActive = value;
    },
    setCustomerInfo(state: IState, value: object) {
      state.mainCustomerInfo = value;
    },
    setOneToOneStrengthening(state: IState, value: boolean) {
      state.isOneToOneStrengthening = value;
    },
    setMainUserInfo(state: IState, value: object) {
      state.mainUserInfo = value;
    },
    setMainShyUserInfo(state: IState, value: object) {
      state.mainShyUserInfo = value;
    },
    setZhichiUserPhone(state: IState, value: string) {
      state.zhichiUserPhone = value;
    },
    setFromWechat(state: IState, value: boolean) {
      state.fromWechat = value;
    },
    setDisturbInfo(state: IState, value: any[]) {
      state.disturbInfo = value;
    },
    setUpdateComPenSateList(state: IState, value: boolean) {
      state.updateComPenSateList = value;
    }
  }
};
